import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export class CloseDealerScheduleListSellerValueObject extends ValueObject {
  /**
   * @param {Object}               deps
   * @param {Array<DealerEntity>}  deps.closeDealerScheduleList
   */

  getList() {
    return this._closeDealerScheduleList
  }
}
